export enum StateEnum {
    LOGIN = 'login',
    SEND_CODE = 'send-code',
    CONFIRM = 'confirm',
    ESIA_ERROR = 'esia-error',
}

export class State {
    state: string;

    constructor() {
        this.start();
    }

    start() {
        this.state = StateEnum.LOGIN;
    }

    isLogin(): boolean {
        return this.state === StateEnum.LOGIN;
    }

    isSendCode(): boolean {
        return this.state === StateEnum.SEND_CODE;
    }

    isConfirm(): boolean {
        return this.state === StateEnum.CONFIRM;
    }

    isEsiaError() {
        return this.state === StateEnum.ESIA_ERROR;
    }

    esiaError(): void {
        this.state = StateEnum.ESIA_ERROR;
    }

    waitConfirm() {
        this.state = StateEnum.CONFIRM;
    }

    next() {
        if (this.state === StateEnum.LOGIN) {
            this.state = StateEnum.SEND_CODE;
        }
    }

    back() {
        if (this.state === StateEnum.SEND_CODE) {
            this.state = StateEnum.LOGIN;
        }
    }
}
